// extracted by mini-css-extract-plugin
module.exports = {"link":"a10a3f92e9--link--ulbh5","without-pointer":"a10a3f92e9--without-pointer--LDp5s"};